import type { CSSObject } from '@mui/material/styles'
import type { Components } from '@mui/material/styles/components'
import { alertColors } from '../colors'

type AlertVariant = 'outlined' | 'standard' | 'filled'
type AlertSeverity = keyof typeof alertColors

const createSeverityStyles = (
  variant: AlertVariant,
  severity: AlertSeverity
): CSSObject => {
  const { border, content, background, icon } = alertColors[severity]

  const base: CSSObject = {
    color: content,
    backgroundColor: background,
    '& .MuiAlert-icon': { color: icon },
    '& .MuiAlertTitle-root': { color: content },
    '& .MuiAlert-action .MuiIconButton-root': { color: content },
  }

  if (variant === 'outlined') {
    return {
      ...base,
      borderColor: border,
    }
  }

  return {
    ...base,
    border: `1px solid ${border}`,
  }
}

export const createAlertStyleOverrides = (): NonNullable<
  Components['MuiAlert']
>['styleOverrides'] => ({
  outlinedError: createSeverityStyles('outlined', 'error'),
  outlinedWarning: createSeverityStyles('outlined', 'warning'),
  outlinedInfo: createSeverityStyles('outlined', 'info'),
  outlinedSuccess: createSeverityStyles('outlined', 'success'),
  standardError: createSeverityStyles('standard', 'error'),
  standardWarning: createSeverityStyles('standard', 'warning'),
  standardInfo: createSeverityStyles('standard', 'info'),
  standardSuccess: createSeverityStyles('standard', 'success'),
  filledError: createSeverityStyles('filled', 'error'),
  filledWarning: createSeverityStyles('filled', 'warning'),
  filledInfo: createSeverityStyles('filled', 'info'),
  filledSuccess: createSeverityStyles('filled', 'success'),
})
